import { IRemitance } from "../../models/Remitance";

export const EmptyRemitance: IRemitance = {
    remittance_ID: undefined,
    // invoiceNo: null,
    
    received_Amount: 0,
    deduction: "",
    reason: "",
    // received_Date: null,
    followUP: "",
    createdBy: null,
    vendor_InvoiceNo: null
}

